import { useState } from "react";
import axios from "axios";

interface UseAuthProps {
  url: string;
  successFunc: (data: any) => void;
  failFunc: (error: any) => void;
}

const useAuth = ({ url, successFunc, failFunc }: UseAuthProps) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<number | null>(null);
  const [error, setError] = useState<any>(null);

  const authenticate = async (username: string, password: string) => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.post(`${url}/auth`, {
        username,
        password,
      });

      // Authorization kontrolü
      if (response.data.authorization !== 1) {
        const authError = new Error("Yetkisiz giriş");
        setError(authError);
        failFunc(authError);
        return;
      }

      setData(response.data.school_id);
      successFunc(response.data);
    } catch (error) {
      setError(error);
      failFunc(error);
    } finally {
      setLoading(false);
    }
  };

  return {
    authenticate,
    loading,
    data,
    error,
  };
};

export default useAuth;
